<hr>

<div class="row">
  <div class="col-12 col-lg-3 py-1">
    <app-read-only-static
      label="{{'authenticated.patients.edit.inquiries.inquiry.form.created_at.label' | translate }}"
      [value]="inquiry.created_at | dfnsParseIso | formatInTimeZone: dfnsLocale: 'medium'"
    ></app-read-only-static>
  </div>

  <div class="col-12 col-lg-3 py-1">
    <app-read-only-static
      label="{{'authenticated.patients.edit.inquiries.inquiry.form.doctor_id.label' | translate }}"
      [value]="inquiry.doctor?.name ?? ''"
    ></app-read-only-static>
  </div>

  <div class="col-12 col-lg-3 py-1">
    @if (canAnswer) {
      <app-multi-select-enum
        [enum]="InquiryStateEnum"
        label="{{'authenticated.patients.edit.inquiries.inquiry.form.state.label' | translate }}"
        [errorMessages]="{required: ('authenticated.patients.edit.inquiries.inquiry.form.state.validation_messages.required' | translate)}"
        [formControl]="form.controls.state"
        [omitValues]="[InquiryStateEnum.OPEN, InquiryStateEnum.WITHDRAWN]"
        [multi]="false"
        translateKey="inquiryStateEnum"
      ></app-multi-select-enum>
    } @else {
      <app-read-only-static
        label="{{'authenticated.patients.edit.inquiries.inquiry.form.state.label' | translate }}"
        [value]="('enums.inquiryStateEnum.' + inquiry.state) | translate"
      ></app-read-only-static>
    }
  </div>

  <div class="col-12 col-lg-3 py-1">
    <app-read-only-static
      label="{{'authenticated.patients.edit.inquiries.inquiry.form.answered_at.label' | translate }}"
      [value]="inquiry.answered_at ? (inquiry.answered_at | dfnsParseIso | formatInTimeZone: dfnsLocale: 'medium') : ''"
    ></app-read-only-static>
  </div>

  <div class="col-12 col-lg-3 py-1">
    <app-read-only-static
      label="{{'authenticated.patients.edit.inquiries.inquiry.form.backoffice_user_id.label' | translate }}"
      [value]="inquiry.backoffice_user?.name ?? ''"
    ></app-read-only-static>
  </div>

  <div class="col-12 col-lg-9 py-1">
    <app-read-only-static
      label="{{'authenticated.patients.edit.inquiries.inquiry.form.question.label' | translate }}"
      [value]="inquiry.question ?? ''"
      type="textarea"
      [minRows]="1"
    ></app-read-only-static>
  </div>

  <div class="col-12 col-lg-12 py-1">
    @if (canAnswer) {
      <app-form-group
        [formControl]="form.controls.answer"
        type="textarea"
        label="{{'authenticated.patients.edit.inquiries.inquiry.form.answer.label' | translate }}"
        [errorMessages]="{required: ('authenticated.patients.edit.inquiries.inquiry.form.answer.validation_messages.required' | translate)}"
      ></app-form-group>
    } @else {
    <app-read-only-static
      label="{{'authenticated.patients.edit.inquiries.inquiry.form.answer.label' | translate }}"
      [value]="inquiry.answer"
      type="textarea"
    ></app-read-only-static>
    }
  </div>

  @if (canWithdraw || canAnswer) {
    <div class="col-12 col-lg-12 pt-1 d-flex justify-content-end gap-4">
      @if (canWithdraw) {
        <button
          class="btn btn-danger"
          type="button"
          (click)="withdrawInquiry()"
          [disabled]="isWaitingForResponse"
        >{{ 'authenticated.patients.edit.inquiries.inquiry.withdraw.btn' | translate }}</button>
      }

      @if (canAnswer) {
        <button
          class="btn btn-primary"
          type="button"
          (click)="save()"
          [disabled]="isWaitingForResponse"
        >{{ 'authenticated.patients.edit.inquiries.inquiry.answer.btn' | translate }}</button>
      }
    </div>
  }
</div>

<ng-template #confirmModal>
  <div class="modal-body text-center">

    <p>{{ 'authenticated.patients.edit.inquiries.inquiry.withdraw.text' | translate: { doctor: inquiry.doctor?.name ?? '' } }}</p>

    <button type="button" class="btn btn-outline-danger me-3" (click)="closeWithdrawModal(true)" >
      {{ 'authenticated.patients.edit.inquiries.inquiry.withdraw.confirm' | translate }}
    </button>

    <button type="button" class="btn btn-secondary ms-3" (click)="closeWithdrawModal(false)" >
      {{ 'authenticated.patients.edit.inquiries.inquiry.withdraw.cancel' | translate }}
    </button>
  </div>
</ng-template>
